module.exports = __webpack_public_path__ + "img/telkie.e0d36c4f.png";